import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  workingArea: {
    flex: 1,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    pointerEvents: 'auto',
  },
  disabled: {
    cursor: 'auto',
    pointerEvents: 'box-only',
  },
});
